import { render, staticRenderFns } from "./SmsPatternManager.vue?vue&type=template&id=f264b130&scoped=true&"
import script from "./SmsPatternManager.vue?vue&type=script&lang=js&"
export * from "./SmsPatternManager.vue?vue&type=script&lang=js&"
import style0 from "./SmsPatternManager.vue?vue&type=style&index=0&id=f264b130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f264b130",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VTab,VTabItem,VTabs,VTabsItems,VTextField})
